import styled from "styled-components";
import { MdKeyboardArrowRight, MdArrowForward } from "react-icons/md";
<link
    href="https://fonts.googleapis.com/css2?family=Righteous&display=swap"
    rel="stylesheet"
></link>;

export const HeroContainer = styled.div`
    background: #0c0c0c;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    height: 700px;
    position: relative;
    z-index: 1;

    :before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0.2) 0%,
                rgba(0, 0, 0, 0.6) 100%
            ),
            linear-gradient(180deg, rgba (0, 0, 0, 0.2) 0%, transparent 100%);
        z-index: 2;
    }
`;

export const HeroBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;
export const VideoBg = styled.video`
    width: 100%;
    height: 100%;
    
    object-fit: cover;
    background: #232a34;
`;
export const HeroContent = styled.div`
    z-index: 3;
    max-width: 1200px;
    position: absolute;
    padding: 8px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;
export const MedianetLogo = styled.img`
    width: 346px;
    max-width: 346px;
    height: 300px;
    @media screen and (max-width: 768px) {
        width: 200px;
        max-width: 200px;
        height: 150px;
    }
    @media screen and (max-width: 480px) {
        width: 100px;
        max-width: 100px;
        height: 75px;
    }
`;
export const HeroH1 = styled.h1`
    color:#0f172a;
    font-size: 48px;
    
    text-align: center;
    text-shadow: #374151 5px 0 10px;
    margin-bottom: 20px;
    @media screen and (max-width: 768px) {
        font-size: 40px;
    }
    @media screen and (max-width: 480px) {
        font-size: 32px;
    } ;
`;
export const HeroH2 = styled.h2`
    color:#0f172a;
    font-size: 48px;
    text-align: center;
    text-shadow: #374151 5px 0 10px;
    @media screen and (max-width: 768px) {
        font-size: 40px;
    }
    @media screen and (max-width: 480px) {
        font-size: 32 px;
    } ;
`;

export const HeroP = styled.p`
    margin-top: 24px;
    color: #991b1b;
    text-shadow: #ffff 1px 0 10px;
    font-size: 24px;
    text-align: center;
    max-width: 600px;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    @media screen and (max-width: 768px) {
        font-size: 24px;
    }
    @media screen and (max-width: 480px) {
        font-size: 18 px;
    } ;
`;
export const HeroBtnWrapper = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ArrowForward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px;
    font-size: 20px;
`;
